/**
 * API functions for managing import templates
 * This file contains functions to fetch, retrieve, and save import templates
 */
import axios from "axios";
import { ImportTemplate } from "@/types";
import getServiceEndpoint from "./ServiceEndpoint";
import { buildClientHeader } from "./buildHeader";

/**
 * Fetches all import templates from the server
 * @returns Promise containing an array of ImportTemplate objects, or empty array if the request fails
 */
export const getImportTemplates = async (): Promise<ImportTemplate[]> => {
  try {
    // todo - selected fund
    const response = await axios.get(
      `${getServiceEndpoint()}/importtemplates`,
      buildClientHeader()
    );

    if (response.status !== 200 || response.data === undefined) {
      console.log("Failed to retrieve import templates", response.statusText);
      return [];
    }

    return response.data ?? [];
  } catch (error) {
    console.error("Error saving import template:", error);
  }
  return [];
};

/**
 * Retrieves a specific import template by its ID
 * @param id The unique identifier of the import template to retrieve
 * @returns Promise containing the requested ImportTemplate object
 */
export const getImportTemplateById = async (
  id: number
): Promise<ImportTemplate> => {
  // todo - selected fund
  const response = await axios.get(
    `${getServiceEndpoint()}/importtemplates/${id}`,
    buildClientHeader()
  );
  return response.data;
};

/**
 * Saves an import template to the server
 * @param template The ImportTemplate object to be saved
 * @returns Promise resolving to true if save was successful, false otherwise
 */
export const saveImportTemplate = async (
  template: ImportTemplate
): Promise<boolean> => {
  try {
    // todo - selected fund
    const response = await axios.post(
      `${getServiceEndpoint()}/importtemplates`,
      JSON.stringify(template),
      buildClientHeader()
    );

    if (response.status !== 200) {
      console.error("Failed to save import template", response.statusText);
      return false;
    }
  } catch (error) {
    console.error("Error saving import template:", error);
    return false;
  }
  return true;
};
